import React from 'react';

import {
    TemplateView,
    editionLevels,
} from '@sunwisesoftware/racking-template-core';
import PropTypes from 'prop-types';

import PdfViewer from 'common/components/PdfViewer';
import { PV_LAYOUT_TYPE, TEMPLATE_TYPES } from 'common/constants';

import PvLayoutViewer from './PvLayoutViewer';

const PreviewContent = ({ editionDisabled, selectedDocument }) => {
    switch (selectedDocument.type) {
        case TEMPLATE_TYPES.PDF_TYPE:
            return (
                <PdfViewer
                    document={{
                        url: selectedDocument.archive,
                    }}
                />
            );
        case PV_LAYOUT_TYPE:
            return <PvLayoutViewer />;
        default:
            return (
                <TemplateView
                    editionLevel={
                        editionDisabled
                            ? editionLevels.NO_EDITION_MODE
                            : editionLevels.PARTIAL_EDITION_MODE
                    }
                />
            );
    }
};

PreviewContent.propTypes = {
    editionDisabled: PropTypes.bool,
    selectedDocument: PropTypes.object,
};

export default PreviewContent;
